<script setup lang="ts">
const props = withDefaults(
	defineProps<{
		blogType: string;
	}>(),
	{
		blogType: "regular",
	},
);

const academyPageName = computed(() =>
	props.blogType === "legal" ? "LegalReferences" : "RegularReferences",
);
</script>

<template lang="pug">
.map-section-wrapper
	.title-container
		.title
			| {{ $t("app.mapSection.titleTop") }} {{ $t("app.mapSection.titleBottom") }}
		.button-wrapper
			router-link.home-page-full-button(
				:to="{ name: academyPageName }",
				aria-label="See all"
			) {{ $t("app.seeAll") }}
	.map-container
		interactive-map(v-if="academyPageName == 'LegalReferences'")
		interactive-map-regular(v-if="academyPageName == 'RegularReferences'")
.button-wrapper-bottom
	router-link.home-page-full-button(
		:to="{ name: academyPageName }",
		aria-label="See all"
	) {{ $t("app.seeAll") }}
</template>

<style lang="scss" scoped>
.map-section-wrapper {
	margin-top: 24px;
	background-image: url("@/assets/image/interactiveMap/map-bg.svg");
	background-repeat: no-repeat;
	background-size: cover;
	background-position: bottom;
	.title-container {
		padding: 24px;
		.title {
			font-family: Pelinka, sans-serif;
			font-size: 18px;
			line-height: 24px;
			font-weight: 700;
			margin: 0 0 24px;
			text-transform: uppercase;
			text-align: center;
		}

		.button-wrapper {
			display: none;
			justify-content: center;
		}
	}

	.map-container {
		display: flex;
		justify-content: center;
		align-items: center;
	}
}

.button-wrapper-bottom {
	background-color: $app-dark-color;
	display: flex;
	justify-content: center;
	padding-bottom: 24px;
}

@media screen and (width >= 760px) {
	.map-section-wrapper {
		.title-container {
			.title {
				font-size: 30px;
				line-height: 38px;
				margin-bottom: 50px;
			}
		}
	}

	.button-wrapper-bottom {
		background-color: $app-dark-color;
		display: flex;
		justify-content: center;
		padding-bottom: 50px;
	}
}

@media screen and (width >= 1024px) {
	.map-section-wrapper {
		padding: 0 85px;
		.title-container {
			padding: 85px 0 0;
			.title {
				font-size: 40px;
				line-height: 46px;
				margin-bottom: 85px;
			}
		}
	}

	.button-wrapper-bottom {
		background-color: $app-dark-color;
		display: flex;
		justify-content: center;
		padding-bottom: 85px;
	}
}

@media screen and (width >= 1572px) {
	.map-section-wrapper {
		margin-top: 24px;
		display: flex;
		background-size: contain;
		.title-container {
			width: 43%;
			.title {
				text-align: start;
				margin: 100px 0 85px;
			}

			.button-wrapper {
				display: flex;
				justify-content: left;
			}
		}

		.map-container {
			width: 60%;
			display: flex;
			align-items: center;
			justify-content: start;
		}
	}

	.button-wrapper-bottom {
		background-color: $app-dark-color;
		display: none;
		justify-content: center;
		padding-bottom: 85px;
	}
}
</style>
